<template>
  <UTooltip
    :text="'Fjern fra handlekurven'"
    :ui="showText ? { container: 'hidden' } : {}"
  >
    <UButton
      class="text-gray-900"
      block
      size="lg"
      icon="i-heroicons-trash"
      color="white"
      :loading="isRemoving"
      @click="removeFromCart"
    >
      <span v-if="showText">Fjern</span>
    </UButton>
  </UTooltip>
</template>

<script lang="ts" setup>
const store = useCartStore();

const props = defineProps({
  itemId: {
    type: String,
    required: true,
  },
  showText: {
    type: Boolean,
    default: false,
  },
});

const isRemoving = ref(false);

const removeFromCart = async () => {
  if (isRemoving.value) {
    return;
  }

  isRemoving.value = true;

  try {
    await store.removeFromCart(props.itemId);
  } catch (error) {
    console.error(error);
  } finally {
    isRemoving.value = false;
  }
};
</script>

<style></style>
